import classNames from "classnames";
import { PropsWithChildren, ReactElement } from "react";
import { ButtonBase } from "../ButtonBase/ButtonBase";
import styles from "./PagerButton.module.less";

export type PagerButtonKind = "arrow" | "page";

const pageButtonKindToStyles: { [key in PagerButtonKind]: string | undefined } = {
	["arrow"]: undefined,
	["page"]: styles.root_page
};

export type PagerButtonProps = {
	kind: PagerButtonKind;
	isActive?: boolean;
	title?: string;
	onClick?(): void;
	isDisabled?: boolean;
	trackingId?: string;
};

export const PagerButton = (props: PropsWithChildren<PagerButtonProps>): ReactElement => {
	const {
		kind,
		isActive = false,
		isDisabled = false,
		title,
		onClick,
		children,
		trackingId
	} = props;

	return (
		<ButtonBase
			trackingId={trackingId}
			className={classNames(
				styles.root,
				pageButtonKindToStyles[kind],
				{
					[styles.root_active]: isActive,
					[styles.root_disabled]: isDisabled
				}
			)}
			onClick={onClick}
			disabled={isDisabled}
			type="button"
			title={title}
			aria-label={title}
		>
			<span className={styles.content}>
				{children}
			</span>
		</ButtonBase>
	);
};

PagerButton.displayName = "PagerButton";